import React, { Fragment, useRef } from "react";
import ScrollToBottom from "react-scroll-to-bottom";
import { connect } from "react-redux";
import { getGifsSearch } from "../../../actions/gif";

import GifItem from "../IME/GifItem";
import DiscussionChatMessageItem from "./DiscussionChatMessageItem";

const DiscussionChat = ({
  auth: { user },
  messages,
  message,
  setMessage,
  deleteMessage,
  showGIFs,
  setshowGIFs,
  gifSearch,
  setGifSearch,
  sendMessage,
  gifs,
  setGif,
  foundGif,
  text,
  setText,
  getGifsSearch,
  setShowChat,
  handleInputChange,
  maxLength,
}) => {
  const inputRef = useRef(null);

  return (
    <Fragment>
      <div className="discussion-live-stream-side-container border-left grey">
        <div className="container-name">
          <i
            className="far fa-window-close fa-2x green close-window"
            onClick={() => setShowChat(false)}
          ></i>
          <p className="container-title green">
            <i className="far fa-comments green mr-5"></i>Chat
          </p>
          <i className="fas fa-external-link-alt fa-lg green pop-out"></i>
        </div>
        <ScrollToBottom className="all-content">
          {messages &&
            messages.map((message, index) => (
              <DiscussionChatMessageItem
                key={index}
                message={message}
                user={user}
                deleteMessage={deleteMessage}
              />
            ))}
        </ScrollToBottom>
        {user.role === "innovator" && (
          <div>
            <div className="comment-gif-input-hidden">
              {showGIFs && foundGif === "" && (
                <div className="giphy-container">
                  <div className="wrap-container">
                    <div className="powered-by-giphy green">Powered By</div>
                    <img
                      src={
                        "https://ime.sfo3.cdn.digitaloceanspaces.com/img/Giphy_Logo.png"
                      }
                      style={{
                        width: "80px",
                        margin: "0px 10px",
                      }}
                      alt="logo"
                    />
                    <i
                      className="far fa-times-circle fa-lg green gif-x"
                      onClick={() => setshowGIFs(false)}
                    ></i>
                  </div>
                  <div className="gifs" id="green-scroll">
                    {!gifSearch &&
                      gifs.map((gif) => (
                        <div
                          className="gif-choice"
                          onClick={(e) => {
                            setGif(e.target.attributes["src"].value);
                            inputRef.current.focus();
                          }}
                        >
                          <GifItem key={gif.id} gif={gif} />
                        </div>
                      ))}
                    {gifSearch &&
                      gifs.map((gif) => (
                        <div
                          className="gif-choice"
                          onClick={(e) => {
                            setGif(e.target.attributes["src"].value);
                            inputRef.current.focus();
                          }}
                        >
                          <GifItem key={gif.id} gif={gif} />
                        </div>
                      ))}
                  </div>
                  <form
                    className="gif-input-hidden"
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (text !== "") {
                        getGifsSearch({ text });
                        setText("");
                        setGifSearch(true);
                      }
                    }}
                  >
                    <input
                      type="text"
                      className="gif-input"
                      name="text"
                      value={text}
                      onChange={(e) => setText(e.target.value)}
                      placeholder="Search for GIFs..."
                    />
                    <button
                      type="submit"
                      onSubmit={(e) => {
                        e.preventDefault();
                        getGifsSearch({ text });
                        setText("");
                        setGifSearch(true);
                        setshowGIFs(false);
                      }}
                      className="gif-input-button background-green"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </form>
                </div>
              )}
            </div>
            <div className="discussion-chat-message-container grey">
              <div className="type-message-container">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                    user && user.avatar
                  }`}
                  className="chat-avi-user"
                />
                {gifs && foundGif !== "" && (
                  <div className="selected-gif-container">
                    <div>
                      <img className="selected-gif" src={gifs && foundGif} />
                      <i
                        className="far fa-times selected-gif-x"
                        onClick={() => {
                          setGif("");
                          setshowGIFs(false);
                        }}
                      ></i>
                    </div>
                    <textarea
                      className={
                        foundGif !== "" ? "chat-textarea-gif" : "chat-textarea"
                      }
                      type="text"
                      value={message}
                      ref={inputRef}
                      onChange={handleInputChange}
                      maxLength={100}
                      onKeyPress={(e) => {
                        if (message.length <= maxLength && e.key === "Enter") {
                          sendMessage(e);
                        } else {
                          alert("Message too long.");
                        }
                      }}
                      placeholder="Type your message here..."
                    ></textarea>
                  </div>
                )}
                {gifs && foundGif === "" && (
                  <textarea
                    className={
                      foundGif !== "" ? "chat-textarea-gif" : "chat-textarea"
                    }
                    type="text"
                    value={message}
                    ref={inputRef}
                    onChange={handleInputChange}
                    maxLength={100}
                    onKeyPress={(e) => {
                      if (message.length <= maxLength && e.key === "Enter") {
                        sendMessage(e);
                      }
                    }}
                    placeholder="Type your message here..."
                  ></textarea>
                )}
              </div>
              <div className="discussion-send-message-container">
                <button
                  type="submit"
                  className="send-message background-green"
                  onClick={() => setshowGIFs(true)}
                >
                  <i className="far fa-images mr-5"></i>Click to search for a
                  GIF
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAutenticated: state.auth.isAuthenticated,
  gif: state.gif,
  episode: state.employerweek,
});

export default connect(mapStateToProps, {
  getGifsSearch,
})(DiscussionChat);
